export default (function (_a) {
    var store = _a.store;
    return ({
        /**
         * 资源认证
         */
        auth: {
            bind: function (el, binding, vnode) {
                // 获取权限编码
                var authCode = binding.value.toString();
                // 验证权限码
                if (!authCode) {
                    console.error('未传入权限');
                    return;
                }
                var hasAuth = (store.state.controlResource || []).findIndex(function (x) { return x.id === authCode; }) > -1;
                // 验证权限
                if (!hasAuth) {
                    el.style.display = 'none';
                }
            }
        }
    });
});
